<template lang="pug">
  .container(id="ShowSelectedMedia-container")
    .header {{$t('Media selected')}}
      el-button.remove-all-button(id="ShowSelectedMedia-clearSelectedMediaButton" @click="clearMediaSelectedLeft()", type='text', size='big', :title='$t("Deselect media")')
        font-awesome-icon(v-if="this.$store.state.Medium.media_selected_left.length > 0", icon="check-square")
        font-awesome-icon(v-if="this.$store.state.Medium.media_selected_left.length === 0", icon="square")
      hr.header
    .row(v-for="selectedMedium in this.$store.state.Medium.media_selected_left", :id="'ShowSelectedMedia-medium' + selectedMedium.id",:key="selectedMedium.id")
      .thumbnail
        img(v-if='selectedMedium.type !== "Audio"', :src="getMediumThumbnailPath(getMediumById(selectedMedium.id))")
      .name
        MediumIcon.icon(:medium='selectedMedium')
        span.medium-name &nbsp; {{ selectedMedium.name }}
      .remove
        el-button(:id="'ShowSelectedMedia-removeMedium' + selectedMedium.id + 'Button'" @click="removeMediumSelectedLeft(selectedMedium)", type='text', size='big', circle, :title='$t("Remove medium from selected")')
          font-awesome-icon(icon="check-square")
</template>

<script>
import MediumIcon from '../Common/MediumIcon'
import ListItemMixin from './ListItem.mixin'
import mediaUtils from '../Common/mediaUtils.mixin'

export default {
  props: [],
  components: {
    MediumIcon
  },
  mixins: [
    ListItemMixin,
    mediaUtils
  ],
  created () {
  },
  watch: {
    items: async function (newVal, oldVal) {
    }
  },
  data () {
    return {
      errors: {}
    }
  },
  methods: {
    removeMediumSelectedLeft (medium) {
      this.$store.dispatch('Medium/removeMediumSelectedLeft', medium)
    },
    clearMediaSelectedLeft () {
      this.$store.dispatch('Medium/clearMediaSelectedLeft')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .container {
    display: flex;
    flex-direction: column;
    .header {
      margin-top: 30px;
      .remove-all-button {
        float: right;
        margin: -15px 30px 0px 0px;
        font-size: 20px;
      }
    }
    .row {
      display: flex;
      padding: 10px 10px;
      border-bottom: $--border-base;
      color: $--color-text-primary;
      font-size: $--font-size-small;
      align-items: center;
      justify-content: space-between;
      .name {
        overflow: hidden;
        // width: 20%;
        flex-grow: 2;
        margin-left: 20px;
      }
      .thumbnail {
        overflow: hidden;
        img {
          max-width: 100px;
        }
      }
      .remove {
        margin-right: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Medium/ShowSelectedMedia.vue